import { log } from "../../../../common/Logging"
import { FontType } from "../../../../common/TextUtils"
import { PhaserText } from "../../../utils/PhaserText"
import { Scale } from "../../../utils/Scale"
import { Sprites } from "../../../utils/Sprites"
import { NicName } from "../TmType"
import { CloseButton } from "./CloseButton"

export class EffectsWindow {
    group: Phaser.Group
    window: Phaser.Sprite
    effects: Phaser.Sprite
    year0: Phaser.Sprite
    year0Text: Phaser.Text
    closeButton: CloseButton
    year: Phaser.Text
    yearNum = -1
    audioClip: Phaser.Sound

    constructor(private game: Phaser.Game, private nicName: NicName, private organ: OrganType, private textBottom: boolean, private onClose: () => void) {
        this.group = game.add.group()
        const group = this.group
        const windowAsset = this.windowAsset(organ)
        const effectsAsset = this.effectsAsset(nicName, organ)

        this.window = Sprites.add(game, windowAsset, {group})
        this.window.x = Scale.x(0.854) - this.window.width
        this.window.y = Scale.y(0.783) - this.window.height

        this.effects = Sprites.add(game, effectsAsset, {group})
        this.effects.x = Scale.x(0.843) - this.effects.width
        this.effects.y = Scale.y(0.769) - this.effects.height

        this.year0 = Sprites.add(game, effectsAsset, {group, x: Scale.x(0.679), y: Scale.y(0.22), scale: 0.5})
        this.year0Text = PhaserText.create(game, "year 0", {
            group, x: this.year0.x + Scale.x(0.005), y: this.year0.y, fontPx: 12, type: FontType.FUTURISTIC
        })
        this.setTextY(this.year0, this.year0Text)
        this.year0.visible = false
        this.year0Text.visible = false

        this.closeButton = new CloseButton(this.game, Scale.x(0.492), Scale.y(0.375), group)
    }

    setTextY = (effectsSprite: Phaser.Sprite, yearText: Phaser.Text) => {
        if (this.textBottom) {
            yearText.y += effectsSprite.height - yearText.height - Scale.x(0.01)
        }
    }

    effectsAsset = (nicName: NicName, organType: OrganType) => `${organType}-${nicName}-effects.json`
    windowAsset = (organType: OrganType) => `${organType}-window.png`

    close = () => {
        this.destroy()
        if (this.audioClip) {
            log.debug("Destroying the audio clip in close.")
            this.audioClip.onStop.removeAll()
            this.audioClip.destroy()
        }
        log.debug("On close now.")
        this.onClose()
    }

    incYearNum = (onComplete: () => void) => {
        this.yearNum++
        if (this.yearNum === 0) {
            this.year = PhaserText.create(this.game, "year 0", {
                group: this.group, x: this.effects.x + Scale.x(0.01), y: this.effects.y, type: FontType.FUTURISTIC
            })
            this.setTextY(this.effects, this.year)
        }

        this.changeYearNum(onComplete)
    }

    decYearNum = (onComplete: () => void) => {
        this.yearNum--

        this.changeYearNum(onComplete)
    }

    nicDoneAudio = () => `time-machine-outro-${this.nicName}-done.mp3`

    nicOutroAudio = () => `time-machine-${this.nicName}-outro-n1.mp3`

    private changeYearNum = (onComplete: () => void) => {
        if (this.audioClip) {
            this.audioClip.stop()
        }

        this.year.text = `year ${this.getYearNum()}`
        if (this.yearNum !== 0) {
            this.year0.visible = true
            this.year0Text.visible = true
        }
        this.effects.frame = this.yearNum
        this.audioClip = this.game.add.audio(this.audioForYear(this.yearNum))
        this.audioClip.play()
        this.audioClip.onStop.addOnce(onComplete)
    }

    private getYearNum = (): string => {
        switch (true) {
            case this.yearNum === 2:
                return "5"
            case this.yearNum === 3:
                return "10"
            default:
                return this.yearNum.toString()
        }
    }

    private destroy = () => this.group.destroy()

    private audioForYear = (year: number) => `time-machine-${this.nicName}-${this.organ}-n${year + 1}.mp3`
}

export enum OrganType {
    MOUTH = "mouth",
    ESOPHAGUS = "esophagus",
    STOMACH = "stomach",
    LUNGS = "lungs",
    HEART = "heart",
}
